export default __webpack_public_path__ + "static/media/l.55bfc3d1.svg";